import { Loader2, CheckCircle2, AlertTriangle, MinusCircle } from 'lucide-react';
import { cn } from '../../../components/ui/utils';
import type { CopyrightStatus } from '../../../shared/api/copyright.api';

interface CopyrightBannerProps {
  status: CopyrightStatus;
}

const CONFIGS = {
  checking: {
    Icon: Loader2,
    iconClassName: 'animate-spin',
    text: 'Проверка авторских прав...',
    className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/30 dark:text-blue-400 dark:border-blue-800',
  },
  clean: {
    Icon: CheckCircle2,
    iconClassName: '',
    text: 'Авторских прав не обнаружено',
    className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-400 dark:border-green-800',
  },
  flagged: {
    Icon: AlertTriangle,
    iconClassName: '',
    text: 'Обнаружено авторское право. Instagram может ограничить видео',
    className: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/30 dark:text-orange-400 dark:border-orange-800',
  },
  error: {
    Icon: MinusCircle,
    iconClassName: '',
    text: 'Не удалось проверить авторские права',
    className: 'bg-muted text-muted-foreground border-border',
  },
} as const;

export function CopyrightBanner({ status }: CopyrightBannerProps) {
  if (status === 'idle') return null;

  const { Icon, iconClassName, text, className } = CONFIGS[status];

  return (
    <div className={cn('flex items-center gap-2 rounded-lg border px-3 py-2 text-sm mt-2', className)}>
      <Icon className={cn('h-4 w-4 shrink-0', iconClassName)} />
      <span>{text}</span>
    </div>
  );
}
